module.exports = __webpack_public_path__ + "static/media/2.5986f149.png";